
export enum GroupStatus {
    Removed = 0,
    Active = 1
   
}